<template>
    <v-dialog v-model="dialog"
              @click:outside="closeDialog"
              scrollable
              max-width="700px"
    >
        <v-card>
           <address-finder @address-confirmed="fillAddress" ref="addressFinderDialog"></address-finder>
            <v-toolbar dense :elevation="0">
                <v-toolbar-title class="text-primary-700">
                    New Scheme
                </v-toolbar-title>
                <div class="flex-grow-1"></div>
                <v-btn icon @click="closeDialog">
                <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="pt-4" style="height:500px; overflow-y: scroll;">
                <form>
                    <h5 class="text-h7 mb-1 pa-0">Scheme Info</h5>
                    <v-row>
                        <v-col cols="8">
                            <v-text-field
                            outlined
                            dense
                            hide-details
                            v-model="form.name"
                            v-validate="'required|min:1'"
                            :error-messages="errors.collect('form.name')"
                            label="Scheme Name"
                            data-vv-name="form.name"
                            data-vv-as="Name"
                            required
                            ></v-text-field>
                        </v-col>
                        <v-col cols="4">
                            <v-select
                            outlined
                            dense
                            hide-details
                            v-model="form.type"
                            :items="schemeTypes"
                            label="Type"
                            required
                            :menu-props="{
                                    offsetY: true,
                                }"
                            v-validate="'required'"
                            :error-messages="errors.collect('form.type')"
                            data-vv-name="form.type"
                            data-vv-as="Type"
                            ></v-select>
                        </v-col>
                        <v-col cols="4">
                            <v-text-field
                            outlined
                            dense
                            hide-details
                            v-model="form.opened_at"
                            v-validate="''"
                            :error-messages="errors.collect('form.opened_at')"
                            label="Opened (Year)"
                            data-vv-name="form.opened_at"
                            data-vv-as="Opened"
                            type="text"
                            v-mask="'####'"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="4">
                            <v-text-field
                            outlined
                            dense
                            hide-details
                            v-model="form.car_spaces"
                            v-validate="'min_value:0'"
                            :error-messages="errors.collect('form.car_spaces')"
                            label="Car Spaces"
                            data-vv-name="form.car_spaces"
                            data-vv-as="Car Spaces"
                            type="number"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="4">
                            <v-checkbox
                            v-model="form.is_under_construction"
                            label="Under Construction?"
                            required
                            hide-details
                            class="mt-1"
                            ></v-checkbox>
                        </v-col>
                    </v-row>
                    
                    <v-divider class="my-8"></v-divider>

                    <template id="section-address">
                      <div style="display: flex; z-index: 20;">
                        <h5 class="text-h7 mb-1 pa-0">Address</h5>
                        <v-spacer></v-spacer>
                        <a style="z-index: 20" @click="selectAddress" class="text-caption">Fill From Map <v-icon small color="primary">mdi-map-marker</v-icon></a>
                      </div>
                      
                      <v-row>
                        <v-col cols="12">
                          <div class="v-input v-input--hide-details v-input--dense theme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined">
                            <div class="v-input__control">
                              <div class="v-input__slot">
                                <fieldset aria-hidden="true"><legend style="width: 45.75px;"><span class="notranslate">​</span></legend></fieldset>
                                <div class="v-text-field__slot">
                                  <label for="input-680" class="v-label v-label--active theme--light" style="left: 0px; right: auto; position: absolute;">Autofill</label>
                                  <!-- <label for="input-349" class="v-label theme--light" style="left: 0px; right: auto; position: absolute;">Street</label> -->
                                  <GmapAutocomplete ref="autocompleteRef" @input="place = $event.target.value" @place_changed="changePlace"></GmapAutocomplete>
                                </div>
                              </div>
                            </div>
                          </div>
                        </v-col>
                      </v-row>
                      <v-row>
                          <v-col cols="6">
                              <v-text-field
                              outlined
                              dense
                              hide-details
                              v-model="form.address.street"
                              v-validate="''"
                              :error-messages="errors.collect('form.address.street')"
                              label="Street"
                              data-vv-name="form.address.street"
                              data-vv-as="Street"
                              ></v-text-field>
                          </v-col>
                          <v-col cols="6">
                              <v-text-field
                              outlined
                              dense
                              hide-details
                              v-model="form.address.street2"
                              v-validate="''"
                              :error-messages="errors.collect('form.address.street2')"
                              label="Street 2 (Optional)"
                              data-vv-name="form.address.street2"
                              data-vv-as="Street 2"
                              ></v-text-field>
                          </v-col>
                      </v-row>
                      <v-row>
                      <v-col cols="4">
                          <v-text-field
                          outlined
                          dense
                          hide-details
                          v-model="form.address.city"
                          v-validate="''"
                          :error-messages="errors.collect('form.address.city')"
                          label="City"
                          data-vv-name="form.address.city"
                          data-vv-as="City"
                          ></v-text-field>
                      </v-col>
                      <v-col cols="4">
                          <v-text-field
                          outlined
                          dense
                          hide-details
                          v-model="form.address.region"
                          v-validate="''"
                          :error-messages="errors.collect('form.address.region')"
                          label="Region"
                          data-vv-name="form.address.region"
                          data-vv-as="Region"
                          ></v-text-field>
                      </v-col>
                      <v-col cols="4">
                          <v-text-field
                          outlined
                          dense
                          hide-details
                          v-model="form.address.post_code"
                          v-validate="''"
                          :error-messages="errors.collect('form.address.post_code')"
                          label="Post Code"
                          data-vv-name="form.address.post_code"
                          data-vv-as="Post Code"
                          ></v-text-field>
                      </v-col>

                      </v-row>
                      <v-row>
                          
                        <v-col cols="12">
                            <v-autocomplete
                            outlined
                            dense
                            hide-details
                            v-model="form.address.country"
                            :items="countries"
                            cache-items
                            flat
                            hide-no-data
                            item-text="name"
                            item-value="name"
                            label="Country"
                            v-validate="''"
                            :error-messages="errors.collect('form.address.country')"
                            data-vv-name="form.address.country"
                            data-vv-as="Country"
                            ></v-autocomplete>
                        </v-col>
                        <!-- <v-col cols="4">
                              <v-text-field
                                  outlined
                                  dense
                                  hide-details
                                  v-model="form.building_num"
                                  v-validate="''"
                                  :error-messages="errors.collect('form.building_num')"
                                  label="Unit"
                                  data-vv-name="form.building_num"
                                  data-vv-as="Unit"
                              ></v-text-field>
                          </v-col> -->
                        <v-col cols="12">
                            <v-textarea
                                outlined
                                dense
                                hide-details  
                                v-model="form.address.notes"
                                v-validate="''"
                                :error-messages="errors.collect('form.address.notes')"
                                label="Notes"
                                data-vv-as="Notes"
                                data-vv-name="form.address.notes"
                                auto-grow
                                rows="1"
                            ></v-textarea>
                        </v-col>
                      </v-row>
                    </template>

                    <v-divider class="my-8"></v-divider>
                    
                    <h5 class="text-h7 mb-1 pa-0">Contacts</h5>
                    <v-row>
                        <v-col cols="6">
                            <v-autocomplete
                            outlined
                            small-chips
                            deletable-chips
                            hide-details
                            v-model="form.landlords"
                            :loading="landlords.loading"
                            :items="landlords.items"
                            :search-input.sync="landlords.search"
                            cache-items
                            chips
                            multiple
                            flat
                            hide-no-data
                            clearable
                            item-text="name"
                            item-value="id"
                            label="Landlords"
                            v-validate="''"
                            :error-messages="errors.collect('form.landlords')"
                            data-vv-name="form.landlords"
                            data-vv-as="Landlords"
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="6">
                            <v-autocomplete
                            outlined
                            small-chips
                            deletable-chips
                            hide-details
                            v-model="form.landlord_contacts"
                            :loading="landlordContacts.loading"
                            :items="landlordContacts.items"
                            :search-input.sync="landlordContacts.search"
                            cache-items
                            chips
                            multiple
                            flat
                            hide-no-data
                            clearable
                            item-text="name"
                            item-value="id"
                            label="Landlord Contacts"
                            v-validate="''"
                            :error-messages="errors.collect('form.landlord_contacts')"
                            data-vv-name="form.landlord_contacts"
                            data-vv-as="Landlord Contacts"
                            ></v-autocomplete>
                        </v-col>
                        <v-col cols="6">
                            <v-autocomplete
                            outlined
                            small-chips
                            deletable-chips
                            hide-details
                            v-model="form.landlord_agents"
                            :loading="landlordAgents.loading"
                            :items="landlordAgents.items"
                            :search-input.sync="landlordAgents.search"
                            cache-items
                            chips
                            multiple
                            flat
                            hide-no-data
                            clearable
                            item-text="name"
                            item-value="id"
                            label="Landlord Agents"
                            v-validate="''"
                            :error-messages="errors.collect('form.landlord_agents')"
                            data-vv-name="form.landlord_agents"
                            data-vv-as="Landlord Agents"
                            >
                            </v-autocomplete>
                        </v-col>
                        <v-col cols="6">
                            <v-autocomplete
                            outlined
                            small-chips
                            deletable-chips
                            hide-details
                            v-model="form.landlord_agent_contacts"
                            :loading="landlordAgentContacts.loading"
                            :items="landlordAgentContacts.items"
                            :search-input.sync="landlordAgentContacts.search"
                            cache-items
                            chips
                            multiple
                            flat
                            hide-no-data
                            clearable
                            item-text="name"
                            item-value="id"
                            label="Landlord Agent Contacts"
                            v-validate="''"
                            :error-messages="errors.collect('form.landlord_agent_contacts')"
                            data-vv-name="form.landlord_agent_contacts"
                            data-vv-as="Landlord Agent Contacts"
                            ></v-autocomplete>
                        </v-col>
                    </v-row>
                </form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn depressed @click="closeDialog">Cancel</v-btn>
                <v-btn depressed :loading="loading"  color="primary" @click="submit">Save</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
import {mask} from 'vue-the-mask'
import countries from '@/data/countries.json'
import CurrencySelect from "@/components/common/currencySelect.vue";
import currencyInput from "@/components/common/currencyInput.vue";
import AddressFinder from "@/components/common/addressFinder.vue";

export default {
  components: {
    CurrencySelect,
    currencyInput,
    AddressFinder,
  },
  directives: {
    mask,
  },
  data: () => ({
    countries: countries,
    dialog: false,
    step: 1,
    schemeTypes: [
      'Leisure',
      'Out of town',
      'Shopping centres',
    ],
    landlordContacts: {
      loading: false,
      items: [],
      search: null,
    },
    landlordAgentContacts: {
      loading: false,
      items: [],
      search: null,
    },
    landlords: {
      loading: false,
      items: [],
      search: null,
    },
    landlordAgents: {
      loading: false,
      items: [],
      search: null,
    },
    loading: false,

    form: {
      name: '',
      type: null,
      opened_at: '',
      is_under_construction: false,
      car_spaces: '',
      landlords: [],
      landlord_contacts: [],
      landlord_agents: [],
      landlord_agent_contacts: [],
      address: {
        street: '',
        street2: '',
        city: '',
        region: '',
        post_code: '',
        country: 'United Kingdom',
        notes: '',
        latitude: null,
        longitude: null,
      },
    }
  }),
  watch: {
    'landlords.search'(search) {
      this.getCompanies(search);
    },
    'landlordContacts.search'(search) {
      this.getUsers(search);
    },
    'landlordAgents.search'(search) {
      this.getCompanies(search);
    },
    'landlordAgentContacts.search'(search) {
      this.getUsers(search);
    },

    "form.landlord_contacts"(val) {
      if (val.length) {
        val.forEach(contact => {
          if (contact.company && !this.form.landlords.find(company => company.id === contact.company_id)) {
            this.form.landlords.push(contact.company.data);
          }
        });
      }
    },

    "form.landlord_agent_contacts"(val) {
      if (val.length) {
        val.forEach(contact => {
          if (contact.company && !this.form.landlord_agents.find(company => company.id === contact.company_id)) {
            this.form.landlord_agents.push(contact.company.data);
          }
        });
      }
    },
  },
  computed: {
    formValidated() {
      return Object.keys(this.fields).some(key => this.fields[key].validated) &&
        Object.keys(this.fields).some(key => this.fields[key].valid)
    }
  },
  methods: {
    closeDialog() {
      this.dialog = false;
    },
    openDialog(address, coordinates) {
      this.dialog = true;
      if (address) {
        this.form.address = address;
      }
      if (coordinates) {
        this.form.address.latitude = coordinates.lat;
        this.form.address.longitude = coordinates.lng;
      }
    },

    clearForm() {
      this.form = {
        name: '',
        type: null,
        opened_at: '',
        is_under_construction: false,
        car_spaces: '',
        landlords: [],
        landlord_contacts: [],
        landlord_agents: [],
        landlord_agent_contacts: [],
        address: {
          street: '',
          street2: '',
          city: '',
          region: '',
          post_code: '',
          country: 'United Kingdom',
          notes: '',
        },
      }
    },

    async getCompanies(search) {
      const response = await this.$http.get('/companies/', {
        params: {
          q: search,
          per_page: 100,
        }
      });
      this.landlords.items = response.data.data;
      this.landlordAgents.items = response.data.data;
    },
    async getUsers(search) {
      const response = await this.$http.get('/users/', {
        params: {
          q: search,
          per_page: 100,
          include: "company",
        }
      });
      this.landlordContacts.items = response.data.data;
      this.landlordAgentContacts.items = response.data.data;
    },

    changePlace(place) {
      const addressComponents = place.address_components;
      const getComponent = (type) => addressComponents.find((component) => component.types.includes(type));

      // Populate address fields
      const streetNumber = getComponent('street_number');
      const route = getComponent('route');
      const locality = getComponent('locality');
      const postalTown = getComponent('postal_town');
      const adminArea = getComponent('administrative_area_level_1'); // State
      const postalCode = getComponent('postal_code');
      const country = getComponent('country');

      let address = {
        line1: streetNumber  && route ? `${streetNumber.long_name} ${route.long_name}` : route ? route.long_name : '',
        line2: '',
        city: locality ? locality.long_name : postalTown ? postalTown.long_name : '',
        state: adminArea ? adminArea.long_name : '',
        zip: postalCode ? postalCode.long_name : '',
        country: country ? country.long_name : '',
      }

      this.fillAddress(address)

    },

    selectAddress() {
      this.$refs.addressFinderDialog.openDialog()
    },
    fillAddress(address) {
      this.form.address = {
        street: '',
        street2: '',
        city: '',
        region: '',
        post_code: '',
        country: '',
        notes: '',
      }

      this.form.address.street = address.line1
      this.form.address.street2 = address.line2
      this.form.address.city = address.city
      this.form.address.region = address.state
      this.form.address.post_code = address.zip
      this.form.address.country = address.country
    },

    async submit() {
      if (await this.$formValidator.validate(this.form)) {
        try {
          await this.$http.post('/schemes', this.form).then(response => {
            let formData = this.form
            formData.id = response.data.data.id
            formData.entity_type = 'scheme'
            this.$emit('added', formData)
            this.clearForm()
            this.closeDialog()
          });
          
        } catch (e) {
          this.$validationException(e)
        }
      }
    }
  }
}
</script>